module.exports = __webpack_public_path__ + "img/emo_25.ef391465.png";